import api from '../api/axiosInstance';

type LicenseStatus = "VALID" | "INVALID";

interface LicenseInfo {
  license: {
    keyId: string;
    type: string;
  };
  licenseStatus: LicenseStatus;
}

interface Data {
  licensesInfo: LicenseInfo[];
  operationalStatusInfo: {
    operationalMode: string;
  };
}

type LicenseFlags = {
  //showArts: boolean;
  swob: boolean;
  nii: boolean;
  kpi: boolean;
};

const KEY_TO_FLAG: Record<string, keyof LicenseFlags> = {
  //FAT1024945: "showArts",
  FAT1024876: "swob",
  FAT1024944: "nii",
  FAT1024898: "kpi",
  
};

export const licenseService = {
    getLicenses: async () => {
        const response = await api.get('/api/license-manager/licenses')
        const flags: LicenseFlags = {
            //showArts: false,
            swob: false,
            nii: false,
            kpi: false,
        };
        const data: Data = response.data;
        for (const item of data.licensesInfo) {
            const flagName = KEY_TO_FLAG[item.license.keyId];
            if (!flagName) continue; // key not mapped, ignore
            flags[flagName] = item.licenseStatus === "VALID";
        }

        return flags;
    }
};